module.exports = __webpack_public_path__ + "img/IMG_2478.cb147d69.jpg";